export const InhabitantTableCellName = {
  AdditionalEmails: 'additional_emails',
  AdditionalPhones: 'additional_phones',
  AddressAddress: 'address_address',
  AddressAddress2: 'address_address_2',
  AddressCity: 'address_city',
  AddressCountry: 'address_country',
  AddressPostcode: 'address_postcode',
  AddressStreet: 'address_street',
  ArchivedAt: 'archived_at',
  Building: 'building',
  BuildingGroup: 'building_group',
  Contracts: 'contracts',
  Created: 'created',
  Email: 'email',
  ExternalId: 'external_id',
  FinancialBankName: 'financial_bank_name',
  FinancialBic: 'financial_bic',
  FinancialDeposit: 'financial_deposit',
  FinancialIban: 'financial_iban',
  FinancialOpenAmount: 'financial_open_amount',
  FinancialPaymentType: 'financial_payment_type',
  FirstName: 'first_name',
  FullName: 'fullname',
  LastInvited: 'last_invited',
  LastName: 'last_name',
  ORAGDepositType: 'orag_deposit_type',
  ORAGFundings: 'orag_fundings',
  ORAGGuaranteedValue: 'orag_guaranteed_value',
  ORAGRemedy: 'orag_remedy',
  ORAGStopOverdueNotice: 'orag_stop_overdue_notice',
  ORAGTerminationDenied: 'orag_termination_denied',
  ORAGTerminationTime: 'orag_termination_time',
  ORAGTerminationTimeframe: 'orag_termination_timeframe',
  PartnerEmail: 'partner_email',
  PartnerFirstName: 'partner_first_name',
  PartnerFullName: 'partner_full_name',
  PartnerLastName: 'partner_last_name',
  PartnerMiddleName: 'partner_middle_name',
  PartnerPhone: 'partner_phone',
  PartnerSalutation: 'partner_salutation',
  PartnerTitle: 'partner_title',
  PersonalFullName: 'personal_full_name',
  PersonalGdprInfo: 'personal_gdpr_info',
  PersonalMiddleName: 'personal_middle_name',
  PersonalNameInfo: 'personal_name_info',
  PersonalPreferredCommunication: 'personal_preferred_communication',
  PersonalSalutation: 'personal_salutation',
  PersonalStatus: 'personal_status',
  PersonalTitle: 'personal_title',
  Phone: 'phone',
  Registered: 'registered',
  Role: 'role',
  Status: 'status',
  Updated: 'updated',
}
